import { render, staticRenderFns } from "./SalesCompanyManage.vue?vue&type=template&id=28754efa&scoped=true&"
import script from "./SalesCompanyManage.vue?vue&type=script&lang=js&"
export * from "./SalesCompanyManage.vue?vue&type=script&lang=js&"
import style0 from "./SalesCompanyManage.vue?vue&type=style&index=0&id=28754efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28754efa",
  null
  
)

export default component.exports